// extracted by mini-css-extract-plugin
var _1 = "ra-heading-center";
var _2 = "ra-heading";
var _3 = "ra-heading-level-1";
var _4 = "ra-heading-level-2";
var _5 = "ra-heading-level-3";
var _6 = "ra-heading-level-4";
var _7 = "ra-heading-level-5";
var _8 = "ra-heading-level-6";
var _9 = "ra-heading-nomargin";
var _a = "ra-heading-normalcase";
var _b = "ra-heading-right";
var _c = "ra-heading-uppercase";
export { _1 as "headingCenterCls", _2 as "headingCls", _3 as "headingLevel1Cls", _4 as "headingLevel2Cls", _5 as "headingLevel3Cls", _6 as "headingLevel4Cls", _7 as "headingLevel5Cls", _8 as "headingLevel6Cls", _9 as "headingNoMarginCls", _a as "headingNormalCaseCls", _b as "headingRightCls", _c as "headingUpperCaseCls" }
